import { combineReducers } from 'redux';
import loginReducer from './login/reducers';

export const getGateway = state => state.gateway;

export default combineReducers({
	login: loginReducer
});
